import SplitIOHandler from 'chameleon/ui-stack/utilities/split-io-handler';

export default function fetchFlags(
  keys,
  uid,
  attributes = {},
  flagWithConfigOptions = {},
  listenCallback = null,
) {
  return new Promise((resolve, reject) => {
    const flagHandler = new SplitIOHandler({
      key: uid || '1',
      splitName: keys,
      attributes,
      ...flagWithConfigOptions,
      callback: (treatment) => {
        if (treatment) {
          resolve(treatment);
        } else {
          reject(new Error('P2 Flag error'));
        }
      },
      listenCallback,
    });
    flagHandler.invoke();
  });
}
